<dx-date-box #dateBox
             class="date-picker-box"
             [value]="value"
             (onValueChanged)="onDateSelected($event)"
             [openOnFieldClick]="true"
             [disabled]="disabled"
             [placeholder]="placeholder"
             [displayFormat]="DateLevelFormat[displayLevel ?? selectLevel]"
             [disabledDates]="isDateDisabled">
  <dxo-calendar-options
    [zoomLevel]="DateLevelZoom[selectLevel].zoomLevel"
    [maxZoomLevel]="DateLevelZoom[selectLevel].maxZoomLevel">
  </dxo-calendar-options>
</dx-date-box>
